import moment from 'moment';

import { CONTRACT_TYPES, RISK_TYPES_VOLATILITY } from '../../../../constants/reports/reports-data';
import Utils from '../../../../utils/immersive_utils';

const formatDateToShort = (rawDate: string): string => {
  if (!rawDate || rawDate.length !== 8) return '';

  const day = rawDate.slice(6, 8);
  const monthNum = rawDate.slice(4, 6);
  const year = rawDate.slice(2, 4);

  const months = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];
  const month = months[parseInt(monthNum, 10) - 1] || '';

  return `${day}${month}${year}`;
};

export const handleOptions = (riskType: string, breakdowns: any[]) => {
  const getOptionsByDate = (riskType: string, breakdowns: any[]) =>
    breakdowns
      .filter(
        (bk) =>
          bk.contract.startsWith(`${CONTRACT_TYPES.OPTIONS}-`) &&
          bk.instrument === CONTRACT_TYPES.TOTAL,
      )
      .map((bk) => {
        const datePart = bk.contract.split('-')[1];
        const label = moment(Utils.parseDate(datePart)).format('YYYY-MM-DD');
        const childOptions = breakdowns
          .filter((option) => {
            const normalizedInstrument = option.instrument?.replace('_', '').replace('.', '-');
            const splitInstrument = normalizedInstrument?.split('-');

            if (!splitInstrument || splitInstrument.length < 2) return false;

            const rawDate = splitInstrument[1];

            const isFormatted = /^[0-9]{1,2}[A-Z]{3}[0-9]{2}$/.test(rawDate);
            const formattedDate = (isFormatted ? rawDate : formatDateToShort(rawDate)).replace(
              /^(\d)([A-Z]{3}\d{2})$/,
              '0$1$2',
            );

            return option.contract === CONTRACT_TYPES.OPTION && formattedDate === datePart;
          })
          .map((option) => {
            const normalizedInstrument = option.instrument?.replace('_', '');
            const splitInstrument = normalizedInstrument?.split('-');

            let formattedLabel = option.instrument;

            if (splitInstrument && splitInstrument.length >= 3) {
              const rawDate = splitInstrument[1];

              const isFormatted = /^[0-9]{1,2}[A-Z]{3}[0-9]{2}$/.test(rawDate);
              const formattedDate = (isFormatted ? rawDate : formatDateToShort(rawDate)).replace(
                /^(\d)([A-Z]{3}\d{2})$/,
                '0$1$2',
              );

              formattedLabel = `${splitInstrument[0]}-${formattedDate}-${splitInstrument.slice(2).join('-')}`;
            }

            return {
              id: `${riskType}-${option.instrument}`,
              label: formattedLabel,
              position: option.position,
              values: option.risk,
            };
          });
        return {
          id: `${riskType}-${bk.instrument}-${bk.contract}`,
          label,
          position: 'Position',
          values: bk.risk,
          children: childOptions,
        };
      });

  if (RISK_TYPES_VOLATILITY.includes(riskType)) {
    const optionsByDate = getOptionsByDate(riskType, breakdowns);
    return optionsByDate;
  } else {
    const totalOptions = breakdowns.find(
      (bk) => bk.contract === CONTRACT_TYPES.OPTIONS && bk.instrument === CONTRACT_TYPES.TOTAL,
    );
    if (!totalOptions) {
      return null;
    }
    const values = totalOptions.risk;
    const optionsByDate = getOptionsByDate(riskType, breakdowns);
    return {
      id: `${riskType}-options`,
      label: 'Options',
      values: values,
      children: optionsByDate,
    };
  }
};
